import { Link } from "react-router-dom";

import { Bullets, Footnote, P, Prose, ProseHeading, ProseTitle } from "../components/prose";
import { CONTACT, LAST_UPDATED } from "../lib/legal";

export function Terms() {
  return (
    <Prose>
      <ProseTitle>Terms</ProseTitle>
      <P>
        Diditake.it lets you write packing templates and publish each collection as a link that the
        Did I Take It? app can subscribe to. Using it means accepting what is below.
      </P>

      <ProseHeading>What you publish is yours, and your responsibility</ProseHeading>
      <P>
        You keep whatever rights you have in what you write here. Publishing a collection means
        letting anyone who has its link — and its access code, if you set one — download it and use
        it on their own devices. That is the whole point of publishing, and it cannot be taken back
        for copies already downloaded: unpublishing stops the service from serving new ones, but a
        template on somebody&rsquo;s phone stays on their phone.
      </P>
      <P>Do not publish through this service:</P>
      <Bullets>
        <li>content you do not have the right to distribute;</li>
        <li>anything unlawful where it is being read, or that exists to harm somebody;</li>
        <li>
          personal data about other people — a packing list has no reason to carry it, and this
          service is not built to hold it.
        </li>
      </Bullets>
      <P>
        Nothing published here is reviewed before it is served. If content is unlawful or is being
        used to attack the service, it may be removed and the account that published it deleted.
      </P>

      <ProseHeading>A packing list is not advice</ProseHeading>
      <P>
        Templates are lists somebody wrote, including the first-aid samples this service ships.
        They are not medical, safety or expedition advice, and nobody has checked them for your
        trip. Dosages, expiry dates, altitude medication, what is legal to carry across a border and
        what a route actually demands are yours to verify. Weights are what the author typed.
      </P>

      <ProseHeading>Availability</ProseHeading>
      <P>
        This runs on one small server, maintained by one person, without a support contract. It may
        be down, it may lose a change you made in the seconds before it went down, and it may be
        retired. Keep an export of anything you would be sorry to lose:{" "}
        <em>Export bundle</em> in the collection menu writes the same JSON the app imports.
      </P>
      <P>
        The service is provided as it is, with no warranty of any kind, and liability is limited to
        what the law does not allow to be excluded.
      </P>

      <ProseHeading>Your account</ProseHeading>
      <P>
        An account exists because a phone registered itself; it has no password to lose, which means
        the recovery code is the only way back in if every authorized device is gone. You can end
        everything at any time from <Link to="/account">Settings</Link>, and what that removes is
        described in the <Link to="/privacy">privacy notice</Link>.
      </P>

      <ProseHeading>Changes</ProseHeading>
      <P>
        These terms may change when the service does. The date below says when they last did; there
        is no notification, because there is no address to notify.
      </P>

      <ProseHeading>Contact</ProseHeading>
      <P>
        <span>{CONTACT}</span>
      </P>

      <Footnote>
        Last updated {LAST_UPDATED}. See also the <Link to="/privacy">privacy notice</Link>.
      </Footnote>
    </Prose>
  );
}
